<div class="item-wrapper" (click)="close()" (keydown)="close()">
  <div class="notification-content d-flex gap-2 align-items-center">
    <img
      src="../../../../assets/icons/svg/notification-mail.svg"
      alt="file"
      class="me-2 mt-1"
    />
    <div class="notification-container d-flex flex-column w-100">
      <div class="d-flex align-items-start justify-content-between gap-1">
        <span class="title">
          {{ notificationData.title }}
        </span>
        <img
          src="../../../../assets/icons/svg/close.svg"
          class="action-i ms-2"
          alt="more"
          height="22"
          width="22"
          (click)="close($event)"
          (keydown)="close($event)"
        />
      </div>
      <p class="description" [innerHtml]="notificationData.body"></p>
      <ng-container
        *ngIf="
          notificationData.source_type == 'CHAT' ||
          notificationData.source_type == 'DATASET'
        "
      >
        <span
          class="hyperlink-text"
          (click)="openNotification($event)"
          (keydown)="openNotification($event)"
          >Click here to view</span
        >
      </ng-container>
    </div>
  </div>
</div>
